import RoutesMap from "../../route_control/RouteControl"
import {
    AddCompany,
    CompanyList,
    UpdateCompany,
    AddCompanyUser,
    CompanyUserList,
    UpdateCompanyUser,
    ItAdminList,
    AddItAdmin,
    UpdateItAdmin,
    ItAdminDetails,
    VendorList,
    AddVendor,
    UpdateVendor,
    VendorDetails,
    VendorEmployeeList,
    AddVendorEmployee,
    UpdateVendorEmployee,
    VendorEmployeeDetails,
    InstituteOnboardingList,
    AddInstituteOnboarding,
    UpdateInstituteOnboarding,
    InstituteOnboardingDetails,
    BranchOfficeList,
    AddBranchOffice,
    UpdateBranchOffice,
    BranchOfficeDetails,
    BranchCourseList,
    AddBranchCourse,
    UpdateBranchCourse
} from "../../pages/company"

export const CompanyRouteImport = {
    RoutesMap,
    AddCompany,
    CompanyList,
    UpdateCompany,
    AddCompanyUser,
    CompanyUserList,
    UpdateCompanyUser,
    ItAdminList,
    AddItAdmin,
    UpdateItAdmin,
    ItAdminDetails,
    VendorList,
    AddVendor,
    UpdateVendor,
    VendorDetails,
    VendorEmployeeList,
    AddVendorEmployee,
    UpdateVendorEmployee,
    VendorEmployeeDetails,
    InstituteOnboardingList,
    AddInstituteOnboarding,
    UpdateInstituteOnboarding,
    InstituteOnboardingDetails,
    BranchOfficeList,
    AddBranchOffice,
    UpdateBranchOffice,
    BranchOfficeDetails,
    BranchCourseList,
    AddBranchCourse,
    UpdateBranchCourse,
}
